import React from "react";
import { useTranslation } from "react-i18next";
import ModalComponent from "../ModalComponent";
import { useUserState } from "../../providers/UserProvider";

function Index({
  handleOpenVideoCallRequest,
  handleCloseVideoCallRequest,
  handleVideoCallRequest,
  loadingRequest,
  name,
  handleConfirmCall,
}) {
  const { t } = useTranslation();
  const user = useUserState();
  let userType = user.user_login?.approve;

  const renderContent = () => {
    switch (userType) {
      case "doctor":
        return (
          <div>
            <p>
              {name} {t("components.RequestVideoCall.doctor.content")}
            </p>
          </div>
        );
      case "user":
        return (
          <div>
            <p>{t("components.RequestVideoCall.user.content")}</p>
          </div>
        );

      default:
        break;
    }
  };

  return (
    <ModalComponent
      open={handleOpenVideoCallRequest}
      handleClose={handleCloseVideoCallRequest}
      closeBtn={true}
      confirmBtn={true}
      handleOk={
        userType === "user" ? handleVideoCallRequest : handleConfirmCall
      }
      loadingRequest={loadingRequest}
      title={t("components.RequestVideoCall.user.title")}
    >
      {renderContent()}
    </ModalComponent>
  );
}

export default Index;
